<template>
    <tr :class="`${isEditRequested || isViewDetailsRequested ? 'edit-row' : ''}`">
        <td>
            <EmptyTextHandler
                :text="`${formatDate(hospitalization.AdmissionDate)} - ${formatDate(hospitalization.DischargeDate)}
                `"
            />
        </td>
        <td><EmptyTextHandler :text="diagnosesList ? diagnosesList : 'Unknown'" /></td>
        <td><EmptyTextHandler :text="hospitalization.DischargedTo" /></td>
        <td><EmptyTextHandler :text="hospitalization.Comments" /></td>
        <td><EmptyTextHandler :text="hospitalization.IsEdEncounter ? 'Y' : 'N'" /></td>
        <td class="text-end">
            <div v-if="!isEditRequested && !isDeleteRequested && !isViewDetailsRequested">
                <button
                    class="btn table-btn btn-outline-info"
                    @click="openEditHospitalization()"
                    v-if="!isEditRequested || isViewDetailsRequested"
                >
                    <i class="fas fa-edit"></i>
                </button>
                <button type="button" class="btn table-btn btn-outline-danger" @click="openDeleteHospitalization()">
                    <i class="fas fa-trash-alt"></i>
                </button>
                <button type="button" class="btn table-btn btn-outline-info" @click="openHospitalizationView()">
                    View Details
                </button>
            </div>
            <i v-if="isEditRequested" class="fw-bold">Edit in Progress</i>
            <div v-if="isDeleteRequested">
                <TablePrompt
                    ok-text="delete"
                    :cancel="closeDeleteHospitalization"
                    message="Are you sure you want to delete this hospitalization?"
                    :ok="deleteHospitalization"
                    :is-in-progress="isDeleteInProgress"
                />
            </div>
        </td>
    </tr>
    <!-- EDIT -->
    <tr class="edit-row" v-if="isEditRequested || isViewDetailsRequested">
        <td :colspan="columns" class="p-3 edit">
            <HospitalAdmissionForm
                :hospitalization="cachedData"
                :cancel-hospitalization="closeEditHospitalization"
                :save-hospitalization="editHospitalization"
                :is-loading="isLoading"
                :provider-id="providerId"
                :roles="roles"
                :patient-info="patientInfo"
                :close-view-details-window="closeViewDetailsWindow"
                :is-view-details-requested="isViewDetailsRequested"
                :application="application"
                :accountId="accountId"
            />
        </td>
    </tr>
</template>

<script lang="ts" src="./HospitalizationsRow.ts" />
